export default __webpack_public_path__ + "static/media/bull-three.1ba38138.png";